import RideDetailsInput from './RideDetailsInput';

export default RideDetailsInput;



// WEBPACK FOOTER //
// ./src/ondemand/components/RideDetailsInput/index.js